<template>
  <div class="page">
    <div class="viewport-info">
      <p>Breite: {{ width }}px</p>
      <p>Höhe: {{ height }}px</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewportInfo',
  data() {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  },
  mounted() {
    window.addEventListener('resize', this.updateSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateSize);
  },
  methods: {
    updateSize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    }
  }
}
</script>

<style scoped lang="scss">
.viewport-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: sans-serif;
  font-size: 1.2rem;
}
</style>
